<template>
  <section class="welcome">
    <div class="container">
      <div class="row align-items-center text-center text-lg-left">
        <div class="col-lg-5">
          <div class="d-bloc d-lg-none">
            <PrimaryTitle class="mb-2">
              <b class="text--size-lg">Sem enrolação<span class="hl">.</span></b>
            </PrimaryTitle>

            <PrimaryTitle class="d-block mb-5">
              <span class="text--size-lg">Aprenda a ganhar dinheiro com quem já chegou lá.</span>
            </PrimaryTitle>
          </div>

          <img src="@/assets/img/peter-cyberclass-2.png" class="img img-fluid" alt="Peter Jordan CyberClass" />
        </div>

        <div class="col-lg-7">
          <div class="container--size-boxed">
            <div class="d-none d-lg-block">
              <PrimaryTitle class="mb-2">
                <b class="text--size-lg">Sem enrolação<span class="hl">.</span></b>
              </PrimaryTitle>

              <PrimaryTitle class="d-block mb-5">
                <span class="text--size-lg">Aprenda a ganhar dinheiro com quem já chegou lá.</span>
              </PrimaryTitle>
            </div>

            <PrimaryParagraph class="mb-4 mt-4 mt-lg-0">Tenha acesso a <strong>lives</strong> e <strong>cursos</strong> criados por experts nas suas áreas. Profissionais que, assim como você, tinham um sonho e conquistaram o sucesso através do conhecimento.</PrimaryParagraph>

            <PrimaryButton
              @click="$router.push({ name: 'subscribe' })"
            >Conquiste seus sonhos</PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PrimaryTitle from '@/components/text/titles/PrimaryTitle'
  import PrimaryParagraph from '@/components/text/paragraphs/PrimaryParagraph'
  import PrimaryButton from '@/components/buttons/PrimaryButton'

  export default {
    components: {
      PrimaryTitle,
      PrimaryParagraph,
      PrimaryButton,
    }
  }
</script>

<style scoped lang="scss">
  .welcome {
    padding-top: 40px;
    background-color: lighten(#000, 96%);
    border-bottom: 1px solid lighten(#000, 95%);

    .img {
      max-width: 380px;
    }

    @media (max-width: 991px) {
      padding-bottom: 40px;

      .img { max-width: 260px }
    }

    .container--size-boxed {
      @media (min-width: 992px) { max-width: 490px }
    }

    .text--size-lg {
      font-size: 2.25rem !important;
    }
  }
</style>
